import BaseSpeedRun from "./BaseSpeedRun.js";
import { getFlagPath } from "../utils/FlagUtils.js";

export default class CapitalNerdSpeedRun extends BaseSpeedRun {
    constructor() {
        super('capitalnerd.speedrun', '.capital-nerd-speed-run', {
            passportStamp: "capital",
            gameNameKey: "home.capitalNerd",
            modeLabelKey: "home.speedRun",
            slug: "capital-nerd-speed-run"
        });
        if (!this.page) return;

        this.init();
    }

    buildProposal(country) {
        return { code: country.code, name: country.name, capital: country.capital };
    }

    renderQuestion(country) {
        return `
            <div class="flag" style="background-image: url(${getFlagPath(country.code)})"></div>
            <div class="name">${country.name}</div>
        `;
    }

    getAnswerLabel(proposal) {
        return proposal.capital;
    }

    buildError(guessBtn) {
        return {
            countryName: this.rightAnswer.name,
            correctCode: this.rightAnswer.code,
            correctCapital: this.rightAnswer.capital,
            guessedCapital: guessBtn.textContent
        };
    }

    renderErrorItem(error) {
        return `
            <div class="error-item">
                <div class="error-country">${error.countryName}</div>
                <div class="error-flag correct">
                    <img src="${getFlagPath(error.correctCode)}" alt="${error.countryName}">
                </div>
                <div class="error-details">
                    <div class="error-answer-text correct">${error.correctCapital}</div>
                    <div class="error-answer-text wrong">${error.guessedCapital}</div>
                </div>
            </div>
        `;
    }
}
